import { combineReducers } from 'redux';

import { SELECT_SOURCE } from 'modules/audits/constants';
import genericSelectSlice, { createClearSelectReducer } from 'modules/global/reducers/generic.selectSlice';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import dashboard from './dashboard';
import details from './details';
import drawer from './drawer';
import link from './link';
import linkedEntities from './linkedEntities';
import { CLEAR_AUDITS_SELECT, FETCH_AUDITS_REQUEST } from '../../actionTypes';

/**
 * @typedef {{
 *   dashboard: import('./dashboard').AuditsUIDashboardReducer,
 *   details: import('./details').AuditsIIDetailsReducer,
 *   link: import('./link').AuditUILinkReducer,
 *   linkedEntities: import('./linkedEntities').LinkedEntitiesReducer,
 *   drawer: import('./drawer').AuditUIDrawerReducer,
 *   selects: import('modules/global/reducers/generic.selectSlice').GenericSelectsReducer,
 * }} AuditUIReducer
 */

export default combineReducers({
  dashboard,
  details,
  link,
  drawer,
  linkedEntities,
  selects: genericSelectSlice(FETCH_AUDITS_REQUEST, {
    global: {
      matcher: ({ meta }) => meta?.source === SELECT_SOURCE && meta?.selectId
    },
    reducers: {
      [LOCATION_CHANGE]: () => ({}),
      [CLEAR_AUDITS_SELECT]: createClearSelectReducer(),
    },
  }),
});
